module.exports = __webpack_public_path__ + "img/1.61d66ca3.png";